<template>
    <!-- the input of one filter, inside a filter pill menu or a More filters section (tasks#211) -->
    <select-filter
        v-if="field.inputType === 'select'"
        :value="value"
        :use-id-field="field.useIdField"
        :use-name-field="field.useNameField"
        :field="field"
        list
        @input="input"
    ></select-filter>
    <search-box
        v-else-if="field.inputType === 'search'"
        :value="value"
        :field="field"
        :debounce="0"
        @input="input"
    ></search-box>
    <date-range-filter
        v-else-if="field.inputType === 'daterange'"
        :value="value"
        :field="field"
        :single-month="singleMonth"
        @input="input"
    ></date-range-filter>
    <date-filter
        v-else-if="field.inputType === 'date'"
        :value="value"
        :field="field"
        @input="input"
    ></date-filter>
    <location-filter
        v-else-if="field.inputType === 'location'"
        :value="value"
        :field="field"
        @input="input"
    ></location-filter>
</template>

<script>
import SearchBox from './SearchBox'
import SelectFilter from './SelectFilter'
import LocationFilter from './LocationFilter'
import DateRangeFilter from './DateRangeFilter'

export default {
    components: {
        SearchBox,
        SelectFilter,
        // a single date filter (cleave.js input masks) loads with the first list that has one
        DateFilter: () => import('./DateFilter'),
        LocationFilter,
        DateRangeFilter,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        field: {
            type: Object,
            required: true,
        },
        // one calendar month instead of two (the 480px side panel)
        singleMonth: {
            type: Boolean,
        },
    },
    methods: {
        input(value) {
            this.$emit('input', value)
        },
    },
}
</script>
